import { getExceptionDetailList, handlingExceptions, handlingException } from '@/routes/ExceptionRecord/services';

export default {
  namespace: 'exception',
  state: {

  },
  effects: {

    // 分页查询异常记录
    * GetExceptionDetailList ({ payload }, { call }) {
      try {
        return yield call(getExceptionDetailList, payload);
      }catch (e) {}
    },
    // 批量处理异常
    * HandlingExceptions ({ payload }, { call }) {
      try {
        return yield call(handlingExceptions, payload);
      }catch (e) {}
    },
    // 单个处理异常
    * HandlingException ({ payload }, { call }) {
      try {
        return yield call(handlingException, payload);
      }catch (e) {}
    },
  },
  reducers: {
    update (state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
